






















































import {
  ref,
  defineComponent,
  toRefs,
  reactive,
  inject,
  computed,
  watch,
  onBeforeMount,
} from '@vue/composition-api'

import { editUserPermissions } from '@/shared/api'
import { alertSymbol } from '@/shared/state-management/symbols'
import { useStore as useTextbookStore } from '@/shared/state-management/textbookStore'
import { User, Textbook, TextbookIssue } from '@/shared/types'
import CloseButton from '@/components/custom/CloseButton.vue'

export default defineComponent({
  name: 'EditUserPermissions',
  components: {
    CloseButton,
  },
  props: {
    users: Array,
  },
  setup(props, context) {
    const EditUserPermissionsForm = ref(null)
    const data = reactive({
      valid: true,
      allowedTextbooks: [],
      allowedTextbookIssues: [],
    })
    const { textbooks } = useTextbookStore().getters

    const loading = ref(false)
    const $alert = inject(alertSymbol) as Function

    const textbookIssues = computed(() =>
      textbooks.value.reduce(
        (issues, textbook) => [...issues, ...textbook.issues],
        []
      )
    )

    const initializeData = (users: User[]): void => {
      if (users.length === 1) {
        const user = users[0]
        data.allowedTextbooks = user.allowedTextbooks.map(
          (textbookId: string) =>
            textbooks.value.find(
              (textbook: Textbook) => textbook.id === textbookId
            )
        )
        data.allowedTextbookIssues = user.allowedTextbookIssues.map(
          (textbookIssueId: string) =>
            textbookIssues.value.find(
              (textbookIssue: TextbookIssue) =>
                textbookIssue.id === textbookIssueId
            )
        )
      }
    }

    onBeforeMount(() => initializeData(props.users as User[]))

    watch(() => props.users as User[], initializeData)

    const submit = async (event: Event) => {
      event.preventDefault()
      event.stopPropagation()
      const form = EditUserPermissionsForm.value
      form.validate()
      if (!data.valid) {
        return
      }
      loading.value = true
      try {
        const userIds = (props.users as Array<User>).map(
          (user: User) => user.id
        )
        const textbookIds = data.allowedTextbooks.map(
          (textbook: Textbook) => textbook.id
        )
        const textbookIssueIds = data.allowedTextbookIssues.map(
          (textbookIssue: TextbookIssue) => textbookIssue.id
        )
        const editedUsers = await editUserPermissions(
          userIds,
          textbookIds,
          textbookIssueIds
        )
        loading.value = false
        $alert({
          text: context.root.$t('users.permissionsEditedSuccess'),
          type: 'success',
        })
        context.emit('permissions-edited', editedUsers)
      } catch (e) {
        loading.value = false
        throw e
      }
    }

    return {
      ...toRefs(data),
      loading,
      EditUserPermissionsForm,
      submit,
      textbooks,
      textbookIssues,
    }
  },
})
